export type AllowedTag = 'strong' | 'br' | 'em' | 's' | 'u' | 'span'

// List of allowed tags for the DOMPurify sanitizer
export const ALLOWED_TAGS: AllowedTag[] = [
  'strong',
  'br',
  'em',
  's',
  'u',
  'span',
]
